import { Injectable, Inject } from '@angular/core';
import { Http, Response, ResponseContentType, RequestOptions, Headers } from '@angular/http';
import { Observable, of, throwError } from 'rxjs';
import { Router } from '@angular/router';
//import 'rxjs/add/operator/map';
//import 'rxjs/add/operator/catch';
//import 'rxjs/add/observable/throw';
import * as moment from "moment";
//import { debounce } from 'rxjs/operator/debounce';
import { map, filter, catchError, mergeMap } from 'rxjs/operators';
import { debug } from 'util';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ResultModel } from '../Models/ResultModel';

@Injectable()
export class PreferenceService {

  myAppUrl: string = "";
  constructor(private _http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
    //this.myAppUrl = baseUrl;
    if (sessionStorage.getItem("BaseURL") != null && sessionStorage.getItem("BaseURL") != "") {
      this.myAppUrl = sessionStorage.getItem("BaseURL") || '';
    }

    //if (this.isTokenExpired()) {
    //    this.Gettoken();
    //}
  }

  savebasicinfo(basicinfo, TokenKey: string): Observable<ResultModel> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Token': TokenKey
      })
    };
    return this._http.post<ResultModel>(this.myAppUrl + 'api/CompanyInformation/AddCompanyInformation', basicinfo, httpOptions)
      .pipe(catchError(this.handleError));
  }

  savelocation(locationlist, TokenKey: string): Observable<ResultModel> {    
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Token': TokenKey
      })
    };
    return this._http.post<ResultModel>(this.myAppUrl + 'api/UserLocation/AddUserLocation', locationlist, httpOptions)
      .pipe(catchError(this.handleError));
  }

  saveans(anslist, logoFile: any, TokenKey: string): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Token': TokenKey
      })
    };
    return this._http.post<any>(this.myAppUrl + 'api/UserPreferenceFormatting/AddUserPreferenceFormatting', anslist, httpOptions)
      .pipe(catchError(this.handleError));
  }

  public uploadFile(fileToUpload: File, userid: any, logoFileName: string, TokenKey: string): Observable<any> {
    const _formData = new FormData();
    _formData.append('file', fileToUpload);
    _formData.append('userid', userid);
    _formData.append('logoFileName', logoFileName);
    return this._http.post<any>(this.myAppUrl + 'api/UserPreferenceFormatting/UploadFile', _formData)
      .pipe(catchError(this.handleError));
  }

  getQuestions(groupid, TokenKey: string, userid: any): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Token': TokenKey
      })
    };
    return this._http.get<any>(this.myAppUrl + "api/QuestionMaster/GetQuestionMaster/null/" + groupid + "/" + userid, httpOptions)
      .pipe(catchError(this.handleError));
  }

  handleError(error: Response | any) {
    console.log(error);
    alert(error);
    console.error(error.message || error);
    return Observable.throw(error);
  }



  //---------------------------------Below code are unused but useful for future    
  //Gettoken() {
  //  let formData = new FormData();
  //  formData.append("ClientID", "Admin");
  //  formData.append("ClientSecret", "abcXyz15s");

  //  this._http.post(this.myAppUrl + 'api/CompanyInformation/Authentication', formData).subscribe(
  //    data => {
  //      var token = data.json();
  //      const expiresAt = moment().add(60, 'minutes');
  //      localStorage.setItem('id_token', token.tokenDetail.token);
  //      localStorage.setItem("expires_at", JSON.stringify(expiresAt.valueOf()));
  //    },
  //    error => {
  //      console.log(JSON.stringify(error.json()));
  //    }
  //  )
  //}

  //isTokenExpired() {
  //  return !this.isLoggedIn();
  //}

  //public isLoggedIn() {
  //  return moment().isBefore(this.getExpiration());
  //}

  //getExpiration() {
  //  const expiration = localStorage.getItem("expires_at");
  //  const expiresAt = JSON.parse(expiration);
  //  return moment(expiresAt);
  //}
}
